// extracted by mini-css-extract-plugin
module.exports = {"nonIdealViewWrapper":"non-ideal-view_nonIdealViewWrapper__ar2qW","nonIdealViewSpacing":"non-ideal-view_nonIdealViewSpacing___Nwas"};